var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4625 9.2925L11.5825 13.1725L7.7025 9.2925C7.3125 8.9025 6.6825 8.9025 6.2925 9.2925C5.9025 9.6825 5.9025 10.3125 6.2925 10.7025L10.8825 15.2925C11.2725 15.6825 11.9025 15.6825 12.2925 15.2925L16.8825 10.7025C17.2725 10.3125 17.2725 9.6825 16.8825 9.2925C16.4925 8.9125 15.8525 8.9025 15.4625 9.2925Z",
    fill: "#565659"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputArrowDown);
export default __webpack_public_path__ + "static/media/input-arrow-down.064915655b45e64e392800e1dc83a2b7.svg";
export { ForwardRef as ReactComponent };